import React from 'react';
import { Link } from 'react-router-dom';
import 'styles/common.css';
import './IntellectualProperty.css';

const IntellectualProperty = () => {
  const ipPortfolio = [
    {
      category: "LLM-Transform-Based Molecular Generation and Optimization Framework",
      items: [
        "Utilizes SMILES (Simplified Molecular Input Line Entry System) strings for molecular representation",
        "Proprietary sequence-to-sequence model based on Transformer architecture",
        "Supports conditional molecular generation aligned with predefined physicochemical properties",
        "Multi-objective molecular optimization capabilities",
        "Pretrained on large-scale open-source databases (ChEMBL, ZINC, PubChem)",
        "Fine-tuning and transfer learning for specific therapeutic targets"
      ]
    },
    {
      category: "Drug Property Prediction Models",
      items: [
        "Deep learning–based predictors including Graph Neural Networks (GNNs)",
        "Transformer architectures and ensemble models",
        "ADMET properties, synthetic feasibility, and bioactivity estimation",
        "Trained on curated datasets from public databases and proprietary experimental data",
        "Superior performance compared with traditional QSAR tools",
        "Iterative feedback into generation module for continuous optimization"
      ]
    },
    {
      category: "Structure-Based Modeling Tools",
      items: [
        "Integration of molecular docking and molecular dynamics simulation modules",
        "Analysis of protein–ligand binding conformations and protein-protein interactions (PPIs)",
        "Structural similarity scoring system for active conformation validation",
        "Compatible with standard protein structure formats (PDB)",
        "Seamless integration with virtual screening pipelines"
      ]
    },
    {
      category: "Integrated Platform Architecture",
      items: [
        "Unified cloud-based platform deployment",
        "End-to-end workflow spanning molecular generation to structural analysis",
        "Command-line interface (CLI) and web-based graphical user interface (GUI)",
        "Designed for computational chemists, medicinal chemists, and drug discovery scientists",
        "Intuitive and efficient user experience"
      ]
    },
    {
      category: "AI-Enabled Intelligent Monitoring and Decision-Support System",
      items: [
        "Intelligent monitoring system for cyanobacteria bloom prediction",
        "Quantitative evaluation of management strategies for Lihu Lake",
        "Multi-source data fusion and Transformer-based time-series modeling",
        "Bayesian change-point detection for high-accuracy forecasting",
        "Real-time early warning and strategic scenario simulation",
        "Scalable architecture for national application potential"
      ]
    }
  ];

  return (
    <div className="ip-page">
      <div className="ip-container">
        <div className="ip-header">
          <Link to="/" className="back-button">← Back to Home</Link>
          <h1 className="ip-title">Intellectual Property</h1>
          <p className="ip-subtitle">Proprietary Technologies and Frameworks</p>
        </div>

        <div className="ip-content">
          <section className="ip-section">
            <h2>Technology Portfolio</h2>
            <p>
              Genion Quantum Technologies has developed a comprehensive portfolio of proprietary 
              technologies and frameworks that form the foundation of our innovative platform. 
              Our intellectual property represents years of research and development in AI, 
              quantum mechanics, and their applications in life sciences.
            </p>
          </section>

          {ipPortfolio.map((ip, index) => (
            <section key={index} className="ip-section">
              <h3>{ip.category}</h3>
              <ul className="ip-list">
                {ip.items.map((item, idx) => (
                  <li key={idx}>{item}</li>
                ))}
              </ul>
            </section>
          ))}

          <section className="ip-section">
            <h2>Commercial Applications</h2>
            <div className="applications-grid">
              <div className="application-card">
                <h4>Pharmaceutical Research</h4>
                <p>Accelerated drug discovery and development processes</p>
              </div>
              <div className="application-card">
                <h4>Environmental Management</h4>
                <p>Advanced monitoring and decision-support systems</p>
              </div>
              <div className="application-card">
                <h4>Biotechnology</h4>
                <p>Novel therapeutic design and optimization</p>
              </div>
              <div className="application-card">
                <h4>Academic Research</h4>
                <p>Advanced tools for scientific discovery and validation</p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default IntellectualProperty;